export function isAxiosError(exception) {
    // https://github.com/axios/axios/blob/cd7ff042b0b80f6f02e5564d184019131c90cacd/lib/core/enhanceError.js#L21
    return exception.isAxiosError === true;
}
//# sourceMappingURL=isAxiosError.js.map